import type { SourceListStatsView, SourceStatusView } from '@/viewmodel/features/sourceState/types';

export function toSourceListStats(statuses: readonly SourceStatusView[]): SourceListStatsView {
  return statuses.reduce<SourceListStatsView>(
    (acc, status) => ({
      healthy: acc.healthy + (status.status === 'ready' ? 1 : 0),
      syncing: acc.syncing + (status.isSyncing ? 1 : 0),
      needsAttention:
        acc.needsAttention + (status.status === 'attention' || status.isFailed ? 1 : 0),
      failed: acc.failed + (status.isFailed ? 1 : 0),
      stale: acc.stale + (status.isStale ? 1 : 0),
    }),
    { healthy: 0, syncing: 0, needsAttention: 0, failed: 0, stale: 0 },
  );
}
